import { Grid, TextField } from '@freighthub/silhouette-core'
import { IQuoteRequest } from 'features/BookingFlow'
import { placeToString } from 'features/Directory'
import { get, isNil } from 'lodash-es'
import { FC } from 'react'
import { useController } from 'react-hook-form'
import { useRootStore } from 'service/useRootStore'
import { useI18n } from 'utils/localisation'
import { z } from 'zod'

import {
  DefaultValuesBehaviour,
  FormFieldsBehaviour,
  FormSchemaBehaviour,
  HeaderBehaviour,
  MQFields,
  SummaryBehaviour,
} from './MQFormContentProcessor'

const MQCustomQuoteHeaderContent: FC = () => {
  const { translate } = useI18n()
  return <>{translate('manual_quote-would_you_like_manual_quote')}</>
}
export class MQCustomQuoteHeaderBehaviour implements HeaderBehaviour {
  content = (<MQCustomQuoteHeaderContent />)
}

const MQCustomQuoteSummaryContent: FC = () => {
  const { translate } = useI18n()
  const {
    authStore: {
      state: { user },
    },
  } = useRootStore()
  return <>{translate('manual_quote-submit_and_receive_quote', { email: get(user, 'email') })}</>
}

export class MQCustomQuoteSummaryBehaviour implements SummaryBehaviour {
  type = 'custom-quote-summary'
  content = (<MQCustomQuoteSummaryContent />)
}

const MQCustomQuoteFormFields: FC = () => {
  const {
    field: { value, onChange },
  } = useController<MQFields, 'additionalInfo'>({
    name: 'additionalInfo',
  })
  const { translate } = useI18n()

  return (
    <Grid xs={12}>
      <TextField
        label={translate('manual_quote-additional_preferences')}
        value={value}
        onChange={onChange}
        fullWidth
        multiline
      />
    </Grid>
  )
}

export class MQCustomQuoteFormFieldsBehaviour implements FormFieldsBehaviour {
  content = (<MQCustomQuoteFormFields />)
}

export class MQCusomQuoteFormSchemaBehaviour implements FormSchemaBehaviour {
  schema = z.object({
    additionalInfo: z.string().optional(),
  })
}

export class MQCustomQuoteDefaultValuesBehaviour implements DefaultValuesBehaviour {
  constructor(private quoteRequest: IQuoteRequest) {}

  defaultValues = {
    cargoReadyAt: !isNil(this.quoteRequest.cargoReadyAt) ? new Date(this.quoteRequest.cargoReadyAt) : undefined,
    deliveryAddress: placeToString(this.quoteRequest.destination),
    deliveryLocation: this.quoteRequest.destination,
    pickupAddress: placeToString(this.quoteRequest.origin),
    pickupLocation: this.quoteRequest.origin,
    incoTerm: this.quoteRequest.incoTerm,
    additionalInfo: '',
  }
}
